<template>
  <o-form-wrapper
    v-model="item"
    :server-errors="_se"
    :v="$v.item"
    :schema="schema"
    :form-state="formState"
  >
    <o-widget-wrapper
      :schema="schema"
      name="name"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        v-model="item.name"
        :form-state="formState"
        name="name"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.name"
      ></o-text-field>
    </o-widget-wrapper>
    <o-widget-wrapper
      :schema="schema"
      name="to_state"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-select
        v-model="item.to_state"
        :items="itemStatesId"
        text-field="name"
        value-field="id"
        sort-field="name"
        :form-state="formState"
        name="to_state"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.to_state"
        store-name="ProcessState"
      >
      </o-select>
      <div class="form-row">
        <div
          class="col-lg-2 col-3 bv-no-focus-ring col-form-label text-right"
        ></div>
        <div class="col">
          <template v-if="checkItemStateId.length > 0" class="container">
            <p class="text-italic text-600">Update to see all Process States</p>
          </template>
        </div>
      </div>
    </o-widget-wrapper>
    <!-- <o-widget-wrapper
      :schema="schema"
      name="activities"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <process-activity-form-table
        v-model="item.activities"
        :validators="$v.item.activities"
        :form-state="formState"
        :label="schema.fields.activities.label"
        :level="level + 1"
        :server-errors="_se.activities"
      >
      </process-activity-form-table> -->
    <!-- UNCOMMENT TO USE Cards
<process-activity-form-cards v-model="item.activities"
    :validators="$v.item.activities"
    :form-state="formState"
    :label="schema.fields.activities.label"
    :level="level+1"
    :server-errors="_se.activities">
</process-activity-form-cards>
-->
    <!-- </o-widget-wrapper> -->
    <o-widget-wrapper
      class="mt-4"
      :schema="schema"
      name="triggers"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-multi-checkbox
        :form-state="formState"
        :items="itemTriggersId"
        :server-errors="_se"
        :validators="$v.item"
        name="triggers"
        sort-field="name"
        text-field="name"
        v-bind="schema.fields.triggers"
        v-model="item.triggers"
        value-field="id"
      ></o-multi-checkbox>
      <div class="form-row">
        <div
          class="col-lg-2 col-3 bv-no-focus-ring col-form-label text-right"
        ></div>
        <div class="col">
          <template v-if="checkItemTriggerId.length > 0" class="container">
            <p class="text-italic text-600">
              Update to see all Process Trigger
            </p>
          </template>

          <div class="text-italic text-600" v-if="extra_triggers.length">
            There is a trigger that doesn't exist any more - Please update/save
            to fix up.
          </div>
        </div>
      </div>
    </o-widget-wrapper>
  </o-form-wrapper>
</template>

<script>
import schema from "../../schema/index";
import { cleanUpModel } from "../../../../vue-ocom/schema/schema_vuetify";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
  VuelidateMixin,
} from "../../../../vue-ocom/mixins";
import { validationMixin } from "vuelidate";
import OWidgetWrapper from "../../../../vue-ocom/components/forms/OWidgetWrapper";
import OTextField from "../../../../vue-ocom/components/forms/fields/OTextField";
import OSelect from "../../../../vue-ocom/components/forms/fields/OSelect";
import OCheckbox from "../../../../vue-ocom/components/forms/fields/OCheckbox";
import OFormWrapper from "../../../../vue-ocom/components/forms/OFormWrapper";
import ODateTime from "../../../../vue-ocom/components/forms/fields/ODateTime";
import OMultiCheckbox from "../../../../vue-ocom/components/forms/fields/OMultiCheckbox.vue";

import { default as ProcessStateForm } from "../../process_state/components/ItemForm";
// import { default as ProcessStateForm } from "../../process_state/components/ItemForm";
import { default as ProcessForm } from "../../process/components/ItemForm";
import { default as ProcessTriggerFormTable } from "../../process_trigger/components/ItemFormTable";
// import { default as ProcessTriggerFormCards } from '../../process_trigger/components/ItemFormCards';
import { default as ProcessActivityFormTable } from "../../process_activity/components/ItemFormTable";
import _ from "lodash";

export default {
  mixins: [
    VuelidateMixin,
    validationMixin,
    CreateFormStateMixin("$v"),
    CreateGroupPermissionMixin("ProcessTransition"),
    CreateCodeTableFetchMixin([]),
  ],
  components: {
    OMultiCheckbox,
    OFormWrapper,
    OWidgetWrapper,
    ODateTime,

    OCheckbox,
    OSelect,
    OTextField,

    ProcessStateForm,
    // ProcessStateForm,
    ProcessForm,
    ProcessTriggerFormTable,
    ProcessActivityFormTable,
    //ProcessTriggerFormCards,
    //ProcessActivityFormCards,
  },
  props: {
    itemStates: { type: Array, default: () => [] },
    itemTriggers: { type: Array, default: () => [] },
    item: { type: Object, default: () => {} },
    level: { type: Number, default: 0 },
    inModal: { type: Boolean, default: false },
  },
  data: () => ({
    schemaModel: cleanUpModel(schema.ProcessTransition, {}),
  }),
  methods: {
    updateTriggersSelected(items) {
      this.item.triggers = items;
    },
  },
  computed: {
    itemStatesId() {
      const result = this.itemStates.filter(
        (i) => i.id != null || i.id != undefined || i.id
      );
      return result;
    },
    itemTriggersId() {
      const result = this.itemTriggers.filter(
        (i) => i.id != null || i.id != undefined || i.id
      );
      return result;
    },
    checkItemStateId() {
      const result = this.itemStates.filter(
        (i) => i.id == null || i.id == undefined || !i.id
      );
      return result;
    },
    checkItemTriggerId() {
      const result = this.itemTriggers.filter(
        (i) => i.id == null || i.id == undefined || !i.id
      );
      return result;
    },
    _se() {
      // Return an empty Object if there are no Server Errors to avoid Binding Errors
      return this.serverErrors || {};
    },
    extra_triggers() {
      var triggerID = _.keyBy(this.itemTriggersId, "id");

      var result = [];
      _.forEach(this.item.triggers, function (t) {
        if (!(t in triggerID)) {
          result.push(t);
        }
      });
      return result;
    },
  },
  watch: {},
  created() {},
};
</script>

<style scoped>
.text-italic {
  font-style: italic;
}
.text-600 {
  font-weight: 600;
}
</style>
